/**
 * FounderBadge — shows a small "FOUNDING MEMBER" pill when the current user
 * is on the Founding Member plan. Used in the top nav, profile drawer,
 * tenant detail header (admin side), and on outgoing client invoice templates.
 * Goes invisible (returns null) for non-founder tenants so nothing visual leaks.
 */
import { Crown } from "lucide-react";

export default function FounderBadge({ size = "sm", className = "" }) {
    const sz = size === "lg"
        ? "px-3 py-1 text-xs"
        : size === "md"
            ? "px-2.5 py-0.5 text-[11px]"
            : "px-2 py-0.5 text-[10px]";
    const iconSz = size === "lg" ? 14 : size === "md" ? 12 : 11;
    return (
        <span
            data-testid="founder-badge"
            title="Founding Member · lifetime badge"
            className={`inline-flex items-center gap-1 rounded-full bg-primary/10 text-primary border border-primary/30 font-semibold uppercase tracking-[0.12em] ${sz} ${className}`}
        >
            <Crown size={iconSz} strokeWidth={2} />
            Founding Member
        </span>
    );
}
